import { BlocksIconUndo } from 'blocks-nextjs/blocks-web-components/components/icon/icons/undo';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconUndo = createComponent({ react: React, tagName: 'cat-icon-undo', elementClass: BlocksIconUndo });
